"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationProvider = exports.TranslationProviderContext = void 0;
var React = require("react");
var TranslationContainer_1 = require("../Translation/TranslationContainer");
var defaultElementConverters_1 = require("../Translation/defaultElementConverters");
var TranslationsService_1 = require("../../TranslationsService");
exports.TranslationProviderContext = React.createContext({
  elementConverters: defaultElementConverters_1.defaultElementConverters,
  container: TranslationContainer_1["default"]
});
exports.TranslationProvider = function (_a) {
  var elements = _a.elements,
    children = _a.children,
    messages = _a.messages,
    locale = _a.locale,
    apiUrl = _a.apiUrl;
  var _b = elements || {},
    elementConverters = _b.elementConverters,
    container = _b.container;
  var elementConvertersList = React.useMemo(function () {
    var result = defaultElementConverters_1.defaultElementConverters;
    if (typeof elementConverters === 'object') {
      Object.keys(elementConverters).forEach(function (converterName) {
        result[converterName] = elementConverters[converterName];
      });
    }
    return result;
  }, [elementConverters]);
  var translationElements = React.useMemo(function () {
    return {
      elementConverters: elementConvertersList,
      container: container || TranslationContainer_1["default"]
    };
  }, [elementConvertersList, container]);
  if (locale) {
    TranslationsService_1.defaultTranslationsService.setConfig({
      locale: locale
    });
  }
  if (apiUrl) {
    TranslationsService_1.defaultTranslationsService.setConfig({
      apiUrl: apiUrl
    });
  }
  if (messages) {
    TranslationsService_1.defaultTranslationsService.setTranslations(messages);
  }
  return React.createElement(exports.TranslationProviderContext.Provider, {
    value: translationElements
  }, children);
};